import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import DragDrop from "../DragDrop";
import ColorPicker from "../core/ColorPicker";
import PhotoCropper from "./PhotoCropper";
import Modal from "../modals/Modal";

import fetchWrapper from "../../lib/apiCall";
import { useAuthInfo } from "../../context/AuthContext";

import calculateAvatarScale from "../../helpers/avatar/calculateAvatarScale";
// import { standardIcons } from "../../helpers/avatar/avatarArrays";
import { getContrastingTextColor } from "../../util/ColorUtil";

const EditAvatar = ({ onClose, onUpdate }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [iconColor, setIconColor] = useState("background_color" || "#ffffff");
  const [imageResults, setImageResults] = useState(null);

  const { userInfo, updateUserInfo } = useAuthInfo();
  const userInitials = `${userInfo?.first_name?.[0] ?? ""}${
    userInfo?.last_name?.[0] ?? ""
  }`;

  const {
    image_url,
    natural_height,
    natural_width,
    position_x,
    position_y,
    scale,
    icon_data,
    avatar_type,
    background_color,
  } = userInfo?.profile_avatar || {};

  const handleColorChange = (color) => {
    const body = {
      color: getContrastingTextColor(color),
      background_color: color,
      avatar_type: avatar_type || "initials",
      icon_data: icon_data || userInitials,
    };

    setIconColor(color);
    return handleAvatarUpdate(body);
  };

  const handleAvatarUpdate = (payload) => {
    return fetchWrapper
      .apiCall(`/avatar`, "PUT", payload)
      .then((data) => {
        if (!data?.results) {
          console.error("Avatar Update: missing results", data);
          return;
        }
        updateUserInfo((previous) => ({
          ...previous,
          profile_avatar: data.results,
        }));
        onUpdate?.(data);
        onClose?.();
      })
      .catch((err) => console.error("Avatar Update: ", err));
  };

  const renderInitialsIcon = () => {
    return (
      <div
        className={`user-initials-icon ${
          avatar_type === "initials" ? "selected" : ""
        }`}
        onClick={() =>
          handleAvatarUpdate({
            avatar_type: "initials",
            icon_data: userInitials,
          })
        }
        style={{
          color: getContrastingTextColor(background_color),
          backgroundColor: background_color,
        }}
      >
        {userInitials}
      </div>
    );
  };

  const renderStandardIcons = () => {
    return standardIcons.map((icon) => {
      return (
        <div
          key={icon}
          className="standard-icons"
          onClick={() =>
            handleAvatarUpdate({ avatar_type: "icon", icon_data: icon || "" })
          }
        >
          <FontAwesomeIcon
            icon={icon}
            className={`${
              avatar_type === "icon" && icon_data === icon ? "selected" : ""
            }`}
            style={{
              color: getContrastingTextColor(
                iconColor ? iconColor : background_color
              ),
              backgroundColor: background_color,
            }}
          />
        </div>
      );
    });
  };

  return (
    <div className="edit-avatar-container">
      {/* <div className="all-icons-wrapper">
        <div className="initial-icon-wrapper">
          <div className="header">Initials</div>
          <div className="initial-icon">{renderInitialsIcon()}</div>
        </div>

        <div className="icons-wrapper">
          <div className="header">Icons</div>
          <div className="icons-list">{renderStandardIcons()}</div>
        </div>
      </div> */}

      <div className="color-picker-wrapper">
        <div className="header">Select a color</div>

        <div className="colors-list">
          <ColorPicker
            initialColor={background_color || userInfo?.color}
            iconColor={background_color}
            handleColor={handleColorChange}
            alwaysOpen={true}
          />
        </div>
      </div>

      {/* <div className="uploaded-icons-wrapper">
        {image_url ? (
          <>
            <div className="header">Uploaded Icon</div>

            <div className="uploaded-icons-wrapper">
              <div
                onClick={() =>
                  handleAvatarUpdate({ avatar_type: "image", icon_data: "" })
                }
                className={`avatar-image ${
                  avatar_type === "image" ? "selected" : ""
                }`}
                style={{
                  backgroundImage: `url(${image_url})`,
                  backgroundSize: calculateAvatarScale(
                    natural_width,
                    natural_height,
                    scale
                  ),
                  backgroundPosition: `${position_x}% ${position_y}%`,
                }}
              />

              <div className="file-upload-input">
                <button
                  onClick={() =>
                    fetchData(
                      `/avatar/${userInfo.profile_avatar.avatar_id}`,
                      "PUT",
                      { initials: userInitials }
                    ).then((result) =>
                      updateUserInfo((previous) => ({
                        ...previous,
                        profile_avatar: result.results,
                      }))
                    )
                  }
                >
                  Delete Image
                </button>

                <button onClick={() => setIsModalOpen(true)}>Edit Image</button>
              </div>
            </div>
          </>
        ) : (
          <div className="file-uploader">
            <DragDrop
              fileType={["image/jpeg", "image/jpg", "image/png"]}
              onSuccessfulUpload={(file) => {
                setImageResults({
                  imageUrl: file.result,
                  imageExt: file.ext,
                  imageType: file.file.type,
                });

                setIsModalOpen(true);
              }}
            />
          </div>
        )}
      </div> */}

      {/* <Modal
        isModalOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        content={{ borderBottomLeftRadius: "0" }}
      >
        <PhotoCropper
          onRequestClose={() => setIsModalOpen(false)}
          handleAvatarUpdate={handleAvatarUpdate}
          imageResults={imageResults}
        />
      </Modal> */}
    </div>
  );
};

export default EditAvatar;
